/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourceTypeEnum } from './resourceTypeEnum';


/**
 * Crowd Strike Config V2
 */
export interface IrrCrowdStrikeConfig { 
    /**
     * Set to false when config is being removed
     */
    enabled: boolean;
    /**
     * API client location
     */
    apiClientLocation?: string;
    /**
     * API client timestamp
     */
    apiClientTimestamp?: string;
    /**
     * API endpoint
     */
    apiEndpoint?: string;
    /**
     * CrowdStrike Org Id
     */
    cid?: string;
    mode?: ResourceTypeEnum;
    /**
     * List of supported email domains for crowdstrike user registration.
     */
    allowedDomains?: Array<string>;
}
export namespace IrrCrowdStrikeConfig {
}


